export default function modalInit() {
    const modal = document.getElementById('modal-country-sites'),
        link = document.querySelector('.js-link-country-sites'),
        modalClose = document.querySelector('.modal__close');

    if(!modal || !link || !modalClose) return;

    link.addEventListener('click', function (e) {
        e.preventDefault();
        modal.style.display = 'block';
    });

    modalClose.addEventListener('click', function () {
        modal.style.display = 'none';
    });
}
